/*
 * remood-reviews.js — avis Judge.me au format éditorial.
 *
 * Lit les avis du <template data-rm-reviews-source> (HTML Judge.me, inerte), les filtre, les trie
 * et rend des cartes dans [data-rm-reviews-target] à partir de <template data-rm-review-card>.
 * Aucun libellé d'interface ici : tout vient des attributs data-* posés par le snippet Liquid.
 * Aucun HTML tiers n'est injecté : on ne lit que du texte (textContent) et on le réinsère en texte.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    if (root.__rmReviewsLoaded) return;
    root.__rmReviewsLoaded = true;
    root.RmReviews = api;
    api.boot(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var ANON_RE = /^\s*(anonym|anonim|an[oó]nimo)/i;

  function int(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  /* Texte d'un nœud en conservant les retours à la ligne (<br>, </p>) mais pas le HTML. */
  function plainText(node) {
    var out = '';
    (function walk(n) {
      for (var c = n.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) {
          out += c.nodeValue.replace(/\s*\n\s*/g, ' ');
        } else if (c.nodeType === 1) {
          var tag = c.tagName.toLowerCase();
          if (tag === 'br') {
            out += '\n';
          } else {
            walk(c);
            if (tag === 'p' || tag === 'div' || tag === 'li') out += '\n\n';
          }
        }
      }
    })(node);
    return out
      .replace(/[ \t]*\n[ \t]*/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/[ \t]{2,}/g, ' ')
      .trim();
  }

  /* Mention ajoutée par Judge.me aux avis traduits : « (Traduit de l'anglais) », « (Translated from German) »… */
  var TRANSLATED_RE = /^[ \t]*\(?[ \t]*(?:traduit|translated|traducido|tradotto|übersetzt|vertaald)[ \t]+(?:de|du|des|from|del|dal|aus|uit)\b[^\n]*$/gim;
  function stripTranslated(text) {
    return String(text || '').replace(TRANSLATED_RE, '').replace(/\n{3,}/g, '\n\n').trim();
  }

  /* URL d'image Judge.me redimensionnée (paramètre width) */
  function sizedImage(url, w) {
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url;
  }

  function textOf(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function parseDate(str) {
    if (!str) return null;
    var d = new Date(String(str).trim().replace(' UTC', 'Z').replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  }

  function safeProductPath(href) {
    if (!href) return '';
    var path = href.split('#')[0];
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[\w\-%.]+$/i.test(path) ? path : '';
  }

  function safeImageUrl(url) {
    if (!url) return '';
    var u = String(url).trim();
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return /^https:\/\/[^\s"'<>]+$/i.test(u) ? u : '';
  }

  /* Photos jointes : liens (pleine taille) et vignettes. On ne garde que des URL https. */
  function parsePics(el) {
    var out = [];
    var seen = {};
    var links = el.querySelectorAll('.jdgm-rev__pics a, .jdgm-rev__pics img');
    for (var i = 0; i < links.length && out.length < 4; i++) {
      var n = links[i];
      var isImg = n.tagName.toLowerCase() === 'img';
      if (isImg && n.closest && n.closest('a')) continue;
      var img = isImg ? n : n.querySelector('img');
      var thumb = safeImageUrl(img && (img.getAttribute('data-src') || img.getAttribute('src')));
      var full = safeImageUrl(isImg ? thumb : n.getAttribute('href')) || thumb;
      if (!thumb) thumb = full;
      if (!full || seen[full]) continue;
      seen[full] = true;
      out.push({ full: full, thumb: thumb });
    }
    return out;
  }

  /* Extrait les avis d'un fragment (template.content ou tout nœud supportant querySelectorAll). */
  function parseReviews(container) {
    var nodes = container.querySelectorAll('.jdgm-rev');
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var ratingEl = el.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? int(ratingEl.getAttribute('data-score'), 0) : 0;
      var timeEl = el.querySelector('.jdgm-rev__timestamp');
      var linkEl = el.querySelector('a.jdgm-rev__prod-link');
      var bodyEl = el.querySelector('.jdgm-rev__body');
      var author = textOf(el.querySelector('.jdgm-rev__author'));
      list.push({
        index: i,
        score: score,
        verified: el.getAttribute('data-verified-buyer') === 'true',
        date: parseDate(timeEl && timeEl.getAttribute('data-content')),
        author: ANON_RE.test(author) ? '' : author,
        location: textOf(el.querySelector('.jdgm-rev__location')),
        title: stripTranslated(textOf(el.querySelector('.jdgm-rev__title'))),
        body: bodyEl ? stripTranslated(plainText(bodyEl)) : '',
        productName: textOf(linkEl),
        productPath: safeProductPath(linkEl && linkEl.getAttribute('href')),
        pics: parsePics(el)
      });
    }
    return list;
  }

  function dedupeKey(r) {
    return r.body.toLowerCase().replace(/\W+/g, ' ').trim().slice(0, 90);
  }

  /* Filtre, trie (longs d'abord, 5★, avec titre, récents) et dédoublonne. */
  function select(reviews, opts) {
    var longThreshold = Math.max(opts.minLength * 2, 120);
    var eligible = reviews.filter(function (r) {
      return r.score >= opts.minScore && r.body.length >= opts.minLength;
    });
    eligible.sort(function (a, b) {
      var pa = a.pics && a.pics.length ? 1 : 0;
      var pb = b.pics && b.pics.length ? 1 : 0;
      if (pa !== pb) return pb - pa;
      var la = a.body.length >= longThreshold ? 1 : 0;
      var lb = b.body.length >= longThreshold ? 1 : 0;
      if (la !== lb) return lb - la;
      if (a.score !== b.score) return b.score - a.score;
      var ta = a.title ? 1 : 0;
      var tb = b.title ? 1 : 0;
      if (ta !== tb) return tb - ta;
      var da = a.date ? a.date.getTime() : 0;
      var db = b.date ? b.date.getTime() : 0;
      if (da !== db) return db - da;
      return a.index - b.index;
    });

    /* Un même avis importé sur plusieurs produits : le produit affiché serait arbitraire. */
    var productsByKey = {};
    reviews.forEach(function (r) {
      var k = dedupeKey(r);
      (productsByKey[k] = productsByKey[k] || {})[r.productPath || r.productName || '_'] = true;
    });
    eligible.forEach(function (r) {
      r.sharedAcrossProducts = Object.keys(productsByKey[dedupeKey(r)]).length > 1;
    });

    var seen = {};
    var perProduct = {};
    var picked = [];
    for (var i = 0; i < eligible.length && picked.length < opts.max; i++) {
      var r = eligible[i];
      var key = dedupeKey(r);
      if (seen[key]) continue;
      if (opts.perProduct > 0) {
        var pk = r.productPath || r.productName || '_';
        if ((perProduct[pk] || 0) >= opts.perProduct) continue;
        perProduct[pk] = (perProduct[pk] || 0) + 1;
      }
      seen[key] = true;
      picked.push(r);
    }
    return picked;
  }

  function fill(card, r, ctx) {
    var q = function (sel) { return card.querySelector(sel); };

    var stars = q('[data-rm-stars]');
    if (stars) {
      var score = Math.max(0, Math.min(5, r.score));
      var on = q('[data-rm-stars-on]');
      var off = q('[data-rm-stars-off]');
      if (on) on.textContent = new Array(score + 1).join('★');
      if (off) off.textContent = new Array(5 - score + 1).join('★');
      var aria = ctx.tpl.getAttribute('data-aria-' + score);
      if (aria) stars.setAttribute('aria-label', aria);
    }

    var title = q('[data-rm-title]');
    if (title && r.title) {
      title.textContent = r.title;
      title.hidden = false;
    }

    var body = q('[data-rm-body]');
    if (body) body.textContent = r.body;

    var author = q('[data-rm-author]');
    if (author) author.textContent = r.author || ctx.tpl.getAttribute('data-anonymous') || '';

    var date = q('[data-rm-date]');
    if (date && r.date) {
      var label = ctx.fmt ? ctx.fmt.format(r.date) : '';
      if (r.location) label = r.location + (label ? ' · ' + label : '');
      date.textContent = label;
      date.hidden = !label;
    } else if (date && r.location) {
      date.textContent = r.location;
      date.hidden = false;
    }

    var verified = q('[data-rm-verified]');
    if (verified) verified.hidden = !r.verified;

    var product = q('[data-rm-product]');
    if (product && ctx.showProduct && r.productName && !r.sharedAcrossProducts) {
      product.textContent = r.productName;
      if (r.productPath) product.setAttribute('href', r.productPath);
      product.hidden = false;
    }

    /* Avis avec photos : la 1re photo en grand en tête de carte, ouverte dans la visionneuse (pas d'onglet) */
    var pics = q('[data-rm-pics]');
    if (pics && r.pics && r.pics.length) {
      var doc = card.ownerDocument;
      var altTpl = ctx.tpl.getAttribute('data-photo-alt') || '';
      var who = r.author || ctx.tpl.getAttribute('data-anonymous') || '';
      var alt = altTpl.replace('{name}', who);
      var btn = doc.createElement('button');
      btn.type = 'button';
      btn.className = 'rm-rev__pic';
      btn.setAttribute('aria-label', (ctx.tpl.getAttribute('data-label-open') || '').replace('{name}', who) || alt);
      var img = doc.createElement('img');
      img.src = sizedImage(r.pics[0].full, 720);
      img.alt = alt;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 720;
      img.height = 540;
      btn.appendChild(img);
      if (r.pics.length > 1) {
        var n = doc.createElement('span');
        n.className = 'rm-rev__pic-count';
        n.setAttribute('aria-hidden', 'true');
        n.textContent = '1 / ' + r.pics.length;
        btn.appendChild(n);
      }
      /* Carte clonée depuis un <template> : on prend le document de la page au moment du clic */
      btn.addEventListener('click', function () { openViewer(btn.ownerDocument, ctx.tpl, r, 0, btn); });
      pics.appendChild(btn);
      pics.hidden = false;
      card.classList.add('rm-rev--pics');
    }

    var more = q('[data-rm-more]');
    if (more) {
      more.textContent = ctx.tpl.getAttribute('data-label-more') || '';
      more.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = ctx.tpl.getAttribute(open ? 'data-label-less' : 'data-label-more') || '';
      });
    }
  }

  /* ── Visionneuse des photos d'un avis (<dialog> unique, partagé) ── */
  var viewer = null;
  function buildViewer(doc, tpl) {
    var d = doc.createElement('dialog');
    d.className = 'rm-lb';
    d.setAttribute('aria-label', tpl.getAttribute('data-label-viewer') || '');
    d.innerHTML =
      '<button type="button" class="rm-lb__btn rm-lb__close" data-lb-close>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<p class="rm-lb__count" data-lb-count aria-live="polite"></p>' +
      '<figure class="rm-lb__fig"><img class="rm-lb__img" data-lb-img alt=""><figcaption class="rm-lb__cap">' +
      '<span class="rm-lb__stars" data-lb-stars></span><span class="rm-lb__who" data-lb-who></span>' +
      '<span class="rm-lb__quote" data-lb-quote></span></figcaption></figure>' +
      '<button type="button" class="rm-lb__btn rm-lb__nav rm-lb__nav--prev" data-lb-prev>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg></button>' +
      '<button type="button" class="rm-lb__btn rm-lb__nav rm-lb__nav--next" data-lb-next>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg></button>';
    d.querySelector('[data-lb-close]').setAttribute('aria-label', tpl.getAttribute('data-label-close') || '');
    d.querySelector('[data-lb-prev]').setAttribute('aria-label', tpl.getAttribute('data-label-prev-photo') || '');
    d.querySelector('[data-lb-next]').setAttribute('aria-label', tpl.getAttribute('data-label-next-photo') || '');
    doc.body.appendChild(d);
    var v = { el: d, review: null, index: 0, opener: null, tpl: tpl };
    var show = function (i) {
      var r = v.review;
      if (!r) return;
      var n = r.pics.length;
      v.index = (i + n) % n;
      var img = d.querySelector('[data-lb-img]');
      img.src = sizedImage(r.pics[v.index].full, 1200);
      var who = r.author || v.tpl.getAttribute('data-anonymous') || '';
      img.alt = (v.tpl.getAttribute('data-photo-alt') || '').replace('{name}', who);
      d.querySelector('[data-lb-count]').textContent = n > 1 ? (v.index + 1) + ' / ' + n : '';
      d.querySelector('[data-lb-prev]').hidden = n < 2;
      d.querySelector('[data-lb-next]').hidden = n < 2;
    };
    v.show = show;
    d.querySelector('[data-lb-close]').addEventListener('click', function () { d.close(); });
    d.querySelector('[data-lb-prev]').addEventListener('click', function () { show(v.index - 1); });
    d.querySelector('[data-lb-next]').addEventListener('click', function () { show(v.index + 1); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(v.index - 1);
      else if (e.key === 'ArrowRight') show(v.index + 1);
    });
    var x0 = null;
    d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (x0 === null || !v.review || v.review.pics.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(v.index + (dx < 0 ? 1 : -1));
    });
    d.addEventListener('close', function () {
      doc.documentElement.classList.remove('rm-lb-lock');
      if (v.opener && v.opener.focus) v.opener.focus();
    });
    return v;
  }

  function openViewer(doc, tpl, r, index, opener) {
    if (!viewer || !viewer.el.isConnected) viewer = buildViewer(doc, tpl);
    var d = viewer.el;
    if (typeof d.showModal !== 'function') { doc.defaultView.open(r.pics[index].full, '_blank', 'noopener'); return; }
    viewer.tpl = tpl;
    viewer.review = r;
    viewer.opener = opener;
    var score = Math.max(0, Math.min(5, r.score));
    var stars = d.querySelector('[data-lb-stars]');
    stars.textContent = new Array(score + 1).join('★');
    stars.setAttribute('aria-label', tpl.getAttribute('data-aria-' + score) || '');
    stars.setAttribute('role', 'img');
    d.querySelector('[data-lb-who]').textContent = r.author || tpl.getAttribute('data-anonymous') || '';
    var quote = r.body.length > 220 ? r.body.slice(0, 217).replace(/\s+\S*$/, '') + '…' : r.body;
    d.querySelector('[data-lb-quote]').textContent = quote;
    viewer.show(index);
    d.showModal();
    doc.documentElement.classList.add('rm-lb-lock');
  }

  /* Avis avec photos d'abord (ordre d'origine conservé sinon) */
  function picsFirst(list) {
    return list.slice().sort(function (a, b) {
      var pa = a.pics && a.pics.length ? 1 : 0;
      var pb = b.pics && b.pics.length ? 1 : 0;
      return pa !== pb ? pb - pa : a.index - b.index;
    });
  }

  /* Affiche « Lire la suite » uniquement si le texte est réellement tronqué. */
  function measure(cards) {
    cards.forEach(function (card) {
      var body = card.querySelector('[data-rm-body]');
      var more = card.querySelector('[data-rm-more]');
      if (!body || !more) return;
      if (card.classList.contains('is-open')) { more.hidden = false; return; }
      more.hidden = !(body.scrollHeight - body.clientHeight > 2);
    });
  }

  function renderHistogram(rootEl, sourceTpl) {
    var group = rootEl.getAttribute('data-rm-group');
    var rowTpl = rootEl.querySelector('template[data-rm-histogram-row]');
    if (!group || !rowTpl) return;
    var targets = rootEl.ownerDocument.querySelectorAll('[data-rm-histogram-for="' + group + '"]');
    if (!targets.length) return;
    var rows = sourceTpl.content.querySelectorAll('.jdgm-histogram__row');
    if (!rows.length) return;
    /* Plusieurs widgets (groupe de produits) : on additionne les fréquences par note. */
    var freq = {};
    var pctOnly = {};
    var totalFreq = 0;
    var hasFreq = true;
    for (var i = 0; i < rows.length; i++) {
      var rating = int(rows[i].getAttribute('data-rating'), 0);
      if (rating < 1 || rating > 5) continue;
      var f = rows[i].getAttribute('data-frequency');
      if (f === null) hasFreq = false;
      freq[rating] = (freq[rating] || 0) + int(f, 0);
      totalFreq += int(f, 0);
      if (!(rating in pctOnly)) pctOnly[rating] = int(rows[i].getAttribute('data-percentage'), 0);
    }
    var data = [];
    Object.keys(pctOnly).forEach(function (k) {
      var r = int(k, 0);
      var pct = hasFreq && totalFreq > 0 ? Math.round(freq[r] * 100 / totalFreq) : pctOnly[r];
      data.push({ rating: r, pct: Math.max(0, Math.min(100, pct)) });
    });
    data.sort(function (a, b) { return b.rating - a.rating; });
    Array.prototype.forEach.call(targets, function (target) {
      target.textContent = '';
      data.forEach(function (d) {
        var row = rowTpl.content.cloneNode(true);
        row.querySelector('[data-rm-hist-label]').textContent = d.rating + ' ★';
        row.querySelector('[data-rm-hist-fill]').style.width = d.pct + '%';
        row.querySelector('[data-rm-hist-pct]').textContent = d.pct + '%';
        target.appendChild(row);
      });
    });
  }

  function hideScope(rootEl) {
    rootEl.hidden = true;
    var scope = rootEl.closest ? rootEl.closest('[data-rm-reviews-scope]') : null;
    if (scope) scope.hidden = true;
  }

  function init(rootEl) {
    if (!rootEl || rootEl.getAttribute('data-rm-init') === '1') return;
    var sourceTpl = rootEl.querySelector('template[data-rm-reviews-source]');
    var cardTpl = rootEl.querySelector('template[data-rm-review-card]');
    var target = rootEl.querySelector('[data-rm-reviews-target]');
    if (!sourceTpl || !cardTpl || !target || !sourceTpl.content) return;
    rootEl.setAttribute('data-rm-init', '1');

    var opts = {
      max: int(rootEl.getAttribute('data-max'), 3),
      minScore: int(rootEl.getAttribute('data-min-score'), 4),
      minLength: int(rootEl.getAttribute('data-min-length'), 60),
      perProduct: int(rootEl.getAttribute('data-per-product'), 0)
    };

    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat(rootEl.getAttribute('data-locale') || 'fr-FR', { month: 'long', year: 'numeric' });
    } catch (e) { /* locale inconnue : pas de date */ }

    var ctx = {
      tpl: cardTpl,
      fmt: fmt,
      showProduct: rootEl.getAttribute('data-show-product') === 'true'
    };

    if (rootEl.hasAttribute('data-paged')) {
      renderHistogram(rootEl, sourceTpl);
      initPaged(rootEl, ctx, sourceTpl, cardTpl, target);
      return;
    }

    var picked = select(parseReviews(sourceTpl.content), opts);
    target.textContent = '';
    var cards = [];
    picked.forEach(function (r) {
      var frag = cardTpl.content.cloneNode(true);
      var card = frag.firstElementChild;
      if (!card) return;
      fill(card, r, ctx);
      target.appendChild(frag);
      cards.push(card);
    });

    renderHistogram(rootEl, sourceTpl);

    if (!cards.length) {
      hideScope(rootEl);
      return;
    }
    target.setAttribute('data-rm-ready', '');

    var doc = rootEl.ownerDocument;
    var win = doc.defaultView || window;
    var run = function () { measure(cards); };
    if (win.requestAnimationFrame) win.requestAnimationFrame(run); else run();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(run);
    var timer;
    win.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 150);
    });
    rootEl.dispatchEvent(new win.CustomEvent('rm:reviews:rendered', { bubbles: true, detail: { count: cards.length } }));
  }


  /* ── Mode paginé : tous les avis, page par page ──────────────────────────────────────────── */

  function renderCards(target, cardTpl, list, ctx) {
    target.textContent = '';
    var cards = [];
    list.forEach(function (r) {
      var frag = cardTpl.content.cloneNode(true);
      var card = frag.firstElementChild;
      if (!card) return;
      fill(card, r, ctx);
      target.appendChild(frag);
      cards.push(card);
    });
    return cards;
  }

  /* Numéros affichés : 1 … (courante ± 1) … dernière. */
  function pageWindow(current, last) {
    var pages = [];
    for (var p = 1; p <= last; p++) {
      if (p === 1 || p === last || Math.abs(p - current) <= 1) pages.push(p);
      else if (pages[pages.length - 1] !== 0) pages.push(0);
    }
    return pages;
  }

  function initPaged(rootEl, ctx, sourceTpl, cardTpl, target) {
    var doc = rootEl.ownerDocument;
    var win = doc.defaultView || window;
    var pager = rootEl.querySelector('[data-rm-pager]');
    var status = rootEl.querySelector('[data-rm-status]');
    var perPage = Math.max(1, Math.min(30, int(rootEl.getAttribute('data-per-page'), 6)));
    var total = int(rootEl.getAttribute('data-total'), 0);
    var endpoint = rootEl.getAttribute('data-endpoint');
    var shop = rootEl.getAttribute('data-shop');
    var productId = rootEl.getAttribute('data-product-id');
    /* Sources : produit courant puis les autres produits du groupe, à la suite. */
    var sources = [];
    (rootEl.getAttribute('data-sources') || '').split(',').forEach(function (part) {
      var bits = part.split(':');
      var n = int(bits[1], 0);
      if (bits[0] && n > 0) sources.push({ id: bits[0], count: n });
    });
    if (!sources.length && productId) sources.push({ id: productId, count: total });
    var sortQuery = rootEl.hasAttribute('data-pics-first') ? '&sort_by=pictures_first&sort_dir=desc' : '';
    var cache = {};
    var rawCache = {};
    var current = 1;
    var busy = false;
    var cards = [];
    /* Mobile : carrousel au doigt (pages ajoutées à la suite), flèches + compteur dessous */
    var mq = win.matchMedia ? win.matchMedia('(max-width: 900px)') : null;
    var rail = !!(mq && mq.matches);
    var railPages = 1;
    var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var initial = parseReviews(sourceTpl.content);
    if (sortQuery) initial = picsFirst(initial);
    if (!initial.length && !total) { hideScope(rootEl); return; }
    if (total < initial.length) total = initial.length;

    function sumSources() {
      var n = 0;
      sources.forEach(function (src) { n += src.count; });
      return n;
    }
    if (sources.length > 1) total = Math.max(total, sumSources());

    function lastPage() { return Math.max(1, Math.ceil(total / perPage)); }

    function label(el, key, page) {
      return (el.getAttribute(key) || '').replace('{page}', page).replace('{total}', lastPage());
    }

    function setStatus(text) { if (status) status.textContent = text; }

    function show(list, append) {
      if (append) {
        var more = [];
        list.forEach(function (r) {
          var frag = cardTpl.content.cloneNode(true);
          var card = frag.firstElementChild;
          if (!card) return;
          fill(card, r, ctx);
          target.appendChild(frag);
          more.push(card);
        });
        cards = cards.concat(more);
      } else {
        cards = renderCards(target, cardTpl, list, ctx);
      }
      target.setAttribute('data-rm-ready', '');
      var run = function () { measure(cards); };
      if (win.requestAnimationFrame) win.requestAnimationFrame(run); else run();
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(run);
    }

    function button(text, page, opts) {
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'rm-pager__btn' + (opts.cls ? ' ' + opts.cls : '');
      b.textContent = text;
      if (opts.aria) b.setAttribute('aria-label', opts.aria);
      if (opts.current) b.setAttribute('aria-current', 'page');
      if (opts.disabled) b.disabled = true;
      if (!opts.current && !opts.disabled) b.setAttribute('data-page', page);
      return b;
    }

    /* ── Carrousel mobile ── */
    function railStep() {
      var c = cards[0];
      if (!c) return target.clientWidth;
      var gap = parseFloat(win.getComputedStyle(target).columnGap) || 12;
      return c.getBoundingClientRect().width + gap;
    }
    function railIndex() {
      return Math.max(0, Math.min(cards.length - 1, Math.round(target.scrollLeft / railStep())));
    }
    function syncRail() {
      if (!rail || !pager) return;
      var i = railIndex();
      var count = pager.querySelector('[data-rm-count]');
      if (count) count.textContent = (i + 1) + ' / ' + Math.max(total, cards.length);
      var prev = pager.querySelector('.rm-pager__prev');
      var next = pager.querySelector('.rm-pager__next');
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= cards.length - 1 && railPages >= lastPage();
      /* Charge la page suivante avant d'arriver au bout */
      if (i >= cards.length - 3 && railPages < lastPage()) loadMore();
    }
    var loadingMore = false;
    function loadMore() {
      if (loadingMore || railPages >= lastPage()) return Promise.resolve();
      loadingMore = true;
      var p = railPages + 1;
      return load(p).then(function (list) {
        if (!rail || !list.length) return;
        railPages = p;
        show(list, true);
      }).catch(function () {}).then(function () {
        loadingMore = false;
        syncRail();
      });
    }
    function railGo(dir) {
      var i = railIndex() + dir;
      var go = function () {
        if (i > cards.length - 1) i = cards.length - 1;
        if (i < 0) i = 0;
        target.scrollTo({ left: i * railStep(), behavior: reduce ? 'auto' : 'smooth' });
      };
      if (i > cards.length - 1 && railPages < lastPage()) loadMore().then(go); else go();
    }
    function buildRailPager() {
      pager.textContent = '';
      pager.hidden = cards.length <= 1;
      setStatus('');
      pager.appendChild(button('←', 0, { cls: 'rm-pager__prev', aria: pager.getAttribute('data-label-prev') }));
      var count = doc.createElement('span');
      count.className = 'rm-pager__count';
      count.setAttribute('data-rm-count', '');
      pager.appendChild(count);
      pager.appendChild(button('→', 0, { cls: 'rm-pager__next', aria: pager.getAttribute('data-label-next') }));
      syncRail();
    }

    function buildPager() {
      if (!pager) return;
      rootEl.classList.toggle('is-rail', rail);
      if (rail) { buildRailPager(); return; }
      var last = lastPage();
      pager.textContent = '';
      pager.hidden = last <= 1;
      if (last <= 1) { setStatus(''); return; }
      pager.appendChild(button('←', current - 1, { cls: 'rm-pager__prev', aria: pager.getAttribute('data-label-prev'), disabled: current <= 1 }));
      pageWindow(current, last).forEach(function (p) {
        if (p === 0) {
          var gap = doc.createElement('span');
          gap.className = 'rm-pager__gap';
          gap.setAttribute('aria-hidden', 'true');
          gap.textContent = '…';
          pager.appendChild(gap);
        } else {
          pager.appendChild(button(String(p), p, { aria: label(pager, 'data-label-page', p), current: p === current }));
        }
      });
      pager.appendChild(button('→', current + 1, { cls: 'rm-pager__next', aria: pager.getAttribute('data-label-next'), disabled: current >= last }));
      if (status) setStatus(label(status, 'data-label-page', current));
    }

    /* Une page Judge.me (taille perPage) d'un produit source, mise en cache. */
    function fetchSourcePage(src, page) {
      var key = src.id + ':' + page;
      if (rawCache[key]) return Promise.resolve(rawCache[key]);
      var url = endpoint +
        '?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify' +
        '&product_id=' + encodeURIComponent(src.id) +
        '&page=' + page +
        '&per_page=' + perPage +
        sortQuery;
      return win.fetch(url, { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          /* HTML Judge.me parsé dans un <template> : inerte (aucun script, aucune image chargée). */
          var tpl = doc.createElement('template');
          tpl.innerHTML = (data && data.html) || '';
          var list = parseReviews(tpl.content);
          if (data && data.total_count > 0) {
            src.count = int(data.total_count, src.count);
            total = sources.length > 1 ? sumSources() : src.count;
          }
          rawCache[key] = list;
          return list;
        });
    }

    /* Avis [from, to) d'une source, en chargeant les pages Judge.me nécessaires. */
    function sliceSource(src, from, to) {
      var first = Math.floor(from / perPage) + 1;
      var last = Math.floor((to - 1) / perPage) + 1;
      var jobs = [];
      for (var p = first; p <= last; p++) jobs.push(fetchSourcePage(src, p));
      return Promise.all(jobs).then(function (pages) {
        var all = [].concat.apply([], pages);
        var offset = (first - 1) * perPage;
        return all.slice(from - offset, to - offset);
      });
    }

    function load(page) {
      if (cache[page]) return Promise.resolve(cache[page]);
      var start = (page - 1) * perPage;
      var end = start + perPage;
      var jobs = [];
      var cursor = 0;
      sources.forEach(function (src) {
        var from = Math.max(start, cursor);
        var to = Math.min(end, cursor + src.count);
        if (from < to) jobs.push(sliceSource(src, from - cursor, to - cursor));
        cursor += src.count;
      });
      return Promise.all(jobs).then(function (parts) {
        var list = [].concat.apply([], parts);
        cache[page] = list;
        return list;
      });
    }

    function go(page, scroll) {
      var last = lastPage();
      if (busy || page < 1 || page > last) return;
      busy = true;
      target.setAttribute('aria-busy', 'true');
      if (status) setStatus(status.getAttribute('data-label-loading') || '');
      load(page)
        .then(function (list) {
          if (!list.length) throw new Error('empty');
          current = page;
          if (rail) railPages = page;
          show(list);
          if (rail) target.scrollLeft = 0;
          buildPager();
          /* Précharge la page suivante : le clic suivant s'affiche sans attente. */
          if (page < lastPage()) load(page + 1).catch(function () {});
          if (scroll) {
            var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var top = rootEl.getBoundingClientRect().top + (win.pageYOffset || 0) - 96;
            win.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
            try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
          }
        })
        .catch(function () {
          if (status) setStatus(status.getAttribute('data-label-error') || '');
        })
        .then(function () {
          busy = false;
          target.removeAttribute('aria-busy');
        });
    }

    if (pager) {
      pager.addEventListener('click', function (e) {
        if (rail) {
          var a = e.target.closest ? e.target.closest('.rm-pager__prev, .rm-pager__next') : null;
          if (a && pager.contains(a) && !a.disabled) railGo(a.classList.contains('rm-pager__next') ? 1 : -1);
          return;
        }
        var b = e.target.closest ? e.target.closest('[data-page]') : null;
        if (b && pager.contains(b)) go(int(b.getAttribute('data-page'), 1), true);
      });
    }
    var railTimer;
    target.addEventListener('scroll', function () {
      if (!rail) return;
      win.cancelAnimationFrame(railTimer);
      railTimer = win.requestAnimationFrame(syncRail);
    }, { passive: true });
    /* Passage mobile ⇄ desktop : on repart de la page 1 */
    if (mq) {
      var onMq = function () {
        if (rail === mq.matches) return;
        rail = mq.matches;
        railPages = 1;
        current = 1;
        show(cache[1] || initial.slice(0, perPage));
        target.scrollLeft = 0;
        buildPager();
      };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    }

    /* Rendu immédiat avec les avis du metafield, puis page 1 de l'API (même tri que les pages
       suivantes) dès qu'il y a plusieurs pages ou que le metafield en contient moins qu'une page. */
    show(initial.slice(0, perPage));
    buildPager();
    if (endpoint && shop && sources.length && win.fetch && (lastPage() > 1 || initial.length < Math.min(perPage, total))) {
      busy = false;
      go(1, false);
    }
    rootEl.dispatchEvent(new win.CustomEvent('rm:reviews:rendered', { bubbles: true, detail: { count: cards.length } }));
  }

  /* Widget Judge.me complet : sans l'app embed, son <style> le garde masqué en permanence.
     À l'ouverture, si le script Judge.me ne l'a pas pris en charge, on le débloque (mise en page sobre). */
  function initFull(details) {
    if (!details || details.getAttribute('data-rm-init') === '1') return;
    details.setAttribute('data-rm-init', '1');
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      var hiding = details.querySelector('style.jdgm-temp-hiding-style');
      var widget = details.querySelector('.jdgm-rev-widg');
      if (hiding && widget) {
        hiding.parentNode.removeChild(hiding);
        widget.classList.add('is-static');
      }
    });
  }

  function initAll(scope) {
    var base = scope || document;
    Array.prototype.forEach.call(base.querySelectorAll('[data-rm-reviews]'), init);
    Array.prototype.forEach.call(base.querySelectorAll('details[data-rm-reviews-full]'), initFull);
  }

  function boot(doc) {
    var go = function () { initAll(doc); };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();
    doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }

  return {
    parseReviews: parseReviews,
    select: select,
    plainText: plainText,
    init: init,
    initAll: initAll,
    boot: boot
  };
});
